// extracted by mini-css-extract-plugin
module.exports = {"root":"MantineCheckbox_root__UyRQR","labelWrapper":"MantineCheckbox_labelWrapper__Nu7ei"};